let _id = 0;

export function getDynamicId() {
  return `${_id++}`;
}
